<template>
  <b-overlay :show="formShow" rounded="sm" no-fade class="mt-1">
    <b-card>
      <b-row class="mb-1">
        <b-col cols="12" md="7" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
          <b-button variant="outline-primary" class="btn-icon" @click="$router.go(-1)">
            <i class="fa-solid fa-arrow-left"></i>
            <span class="ml-25">Back</span>
          </b-button>
        </b-col>
      </b-row>

      <b-row class="mb-1">
        <table class="table table-sm">
          <thead>
            <tr>
              <th scope="col">{{ recordId ? 'Potential Impact Edit' : 'Potential Impact Add' }}</th>
            </tr>
          </thead>
        </table>
      </b-row>

      <validation-observer ref="formRules">
        <b-form>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Risk" label-for="risk_objective_id">
                <validation-provider name="risk_objective_id" #default="{ errors }">
                  <v-select
                    id="risk_objective_id"
                    v-model="formData.risk_objective_id"
                    :options="objectiveOptions"
                    :reduce="(opt) => opt.id"
                    label="title"
                    placeholder="Select Risk"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group label="Title" label-for="title">
                <validation-provider name="title" #default="{ errors }" rules="required">
                  <b-form-input id="title" type="text" v-model="formData.title" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <hr />

          <b-row>
            <b-col cols="12">
              <b-button type="submit" @click.prevent="formSubmitted" variant="primary" class="float-right">
                {{ recordId ? 'Save Changes' : 'Save' }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </b-overlay>
</template>

<script>
import store from '@/store';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { onUnmounted } from '@vue/composition-api';
import settingsStoreModule from '../settingsStoreModule';
import vSelect from 'vue-select';
import router from '@/router';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';

export default {
  components: { vSelect, ToastificationContent, ValidationProvider, ValidationObserver },
  setup() {
    if (!store.hasModule('settings')) store.registerModule('settings', settingsStoreModule);
    onUnmounted(() => { if (store.hasModule('settings')) store.unregisterModule('settings'); });
  },
  data() {
    return {
      formData: { title: '', risk_objective_id: null },
      formShow: false,
      recordId: null,
      objectiveOptions: [],
      required,
    };
  },
  mounted() {
    store.dispatch('settings/getAllRiskObjectives').then((res) => {
      this.objectiveOptions = res.data;
    });

    if (router.currentRoute.params.id) {
      this.recordId = parseInt(router.currentRoute.params.id);
      this.formShow = true;
      store.dispatch('settings/getRiskImpactById', { id: this.recordId }).then((res) => {
        this.formData = { title: res.data.title, risk_objective_id: res.data.risk_objective_id };
        this.formShow = false;
      }).catch(() => { this.formShow = false; });
    }
  },
  methods: {
    formSubmitted() {
      this.$refs.formRules.validate().then((success) => {
        if (!success) return;
        this.formShow = true;
        const action = this.recordId ? 'settings/updateRiskImpact' : 'settings/saveRiskImpact';
        const payload = this.recordId ? { ...this.formData, id: this.recordId } : this.formData;
        store.dispatch(action, payload).then(() => {
          this.$toast({ component: ToastificationContent, props: { title: 'Successful', text: `✔️ Potential Impact ${this.recordId ? 'updated' : 'added'} successfully`, icon: 'ThumbsUpIcon', variant: 'success' } });
          router.push({ name: 'settings-risk-impacts' });
        }).catch((err) => {
          this.formShow = false;
          const msg = err.response?.data?.errors?.title?.[0] || 'An error occurred.';
          this.$toast({ component: ToastificationContent, props: { title: 'Error', text: msg, icon: 'AlertCircleIcon', variant: 'danger' } });
        });
      });
    },
  },
};
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
